// StavStitok — päť stavov V3 (ústava 131.8): štítok s textom, farba ho len dopĺňa (61.8 bez guličiek).
// Použitie: <StavStitok stav="prebieha" />  ·  <StavStitok stav="chyba" text="Po termíne" />
import React from 'react'
import { COLORS, TYPO } from '../theme.js'

export const STAVY = {
  chyba:     { label: 'Chyba',       fg: COLORS.remove, bg: COLORS.removeBg },
  zasah:     { label: 'Treba zásah', fg: COLORS.total,  bg: COLORS.totalBg },
  hotovo:    { label: 'Hotovo',      fg: COLORS.add,    bg: COLORS.addBg },
  prebieha:  { label: 'Prebieha',    fg: COLORS.nav,    bg: COLORS.navBg },
  // COLORS.muted na lineSoft má len 4,39:1 (pod WCAG AA pri 11 px)
  neutralne: { label: 'Neutrálne',   fg: COLORS.text,   bg: COLORS.lineSoft },
}

export default function StavStitok({ stav, text, title }) {
  const s = STAVY[stav] || STAVY.neutralne
  return (
    <span title={title || undefined} style={{ display: 'inline-block', maxWidth: '100%', boxSizing: 'border-box', height: 20, lineHeight: '20px', padding: '0 8px', borderRadius: 10, fontSize: TYPO.sizes.xs, fontWeight: TYPO.weights.bold, color: s.fg, background: s.bg, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', verticalAlign: 'middle' }}>
      {text || s.label}
    </span>
  )
}
